import PreviewOutcome from './PreviewOutcome'

export default PreviewOutcome
